module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS11.729b2c0b.jpg";